<template>
  <div
    id="EditBarcodeModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <!--begin::Form-->
      <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">แก้ไขข้อมูล BARCODE</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">BARCODE:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="ebBarcodeOld"
                        ref="ebBarcodeOld"
                        name="ebBarcodeOld"
                        placeholder="BARCODE"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label>รหัสทรัพย์สิน(เบียร์สด):</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="ebDepartmentMaterialCode"
                        ref="ebDepartmentMaterialCode"
                        placeholder="รหัสทรัพย์สิน(เบียร์สด)"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">ปี(สินค้า):</label>
                      <div class="input-group">
                        <input
                          type="text" 
                          v-model="ebBarcodeYear" 
                          name="ebBarcodeYear" 
                          class="form-control" 
                          maxlength="4" 
                          @input="validateYearInput"
                          placeholder="ปี(สินค้า)"
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label>รหัสทรัพย์สิน(บัญชี):</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="ebAccountMaterialCode"
                        ref="ebAccountMaterialCode"
                        placeholder="รหัสทรัพย์สิน(บัญชี)"
                        />
                    </div>
                  </div>

                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label">BARCODE COOLING:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="ebBarcodeCL"
                        ref="ebBarcodeCL"
                        placeholder="BARCODE COOLING"
                        maxlength="20"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">ชื่อสินค้า:</label>
                      <treeselect
                        v-model="ebAssetCode"
                        ref="ebAssetCode"
                        :options="ebAssetCodeOptions"
                        :clear-on-select="true"
                        :class="{ 'invalid-treeselect': !ebAssetCode }"
                        placeholder="กรุณาเลือก"
                      />
                      <span class="form-text text-danger" style="font-size: 80%;" v-if="!ebAssetCode">กรุณาเลือก ชื่อสินค้า</span>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">เจ้าของทรัพย์สิน:</label>
                      <treeselect
                        v-model="ebAssetOwnerId"
                        :options="ebAssetOwnerOptions"
                        :clear-on-select="true"
                        :class="{ 'invalid-treeselect': !ebAssetOwnerId }"
                        placeholder="กรุณาเลือก"
                      />
                      <span class="form-text text-danger" style="font-size: 80%;" v-if="!ebAssetOwnerId">กรุณาเลือก เจ้าของทรัพย์สิน</span>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">Supplier:</label>
                      <treeselect
                        v-model="ebSupplierId"
                        :options="ebSupplierOptions"
                        :clear-on-select="true"
                        :class="{ 'invalid-treeselect': !ebSupplierId }"
                        placeholder="กรุณาเลือก"
                      />
                      <span class="form-text text-danger" style="font-size: 80%;" v-if="!ebSupplierId">กรุณาเลือก Supplier</span>
                    </div>
                  </div>

                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">วันที่เริ่มต้น:</label>
                      <div class="input-group date">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="วันที่เริ่มต้น (วว/ดด/ปปปป)"
                          ref="ebWarrantyStartDate"
                          name="ebWarrantyStartDate"
                        />
                        <div class="input-group-append">
                          <span class="input-group-text">
                            <i class="la la-calendar"></i>
                          </span>
                        </div>
                      </div>
                      <span class="form-text"></span>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">ระยะเวลาประกัน(วัน):</label>
                      <input
                        type="number"
                        class="form-control"
                        min="0"
                        placeholder="ระยะเวลาประกัน(วัน)"
                        v-model="ebWarrantyTime"
                        name="ebWarrantyTime"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">อายุของทรัพย์สิน(วัน):</label>
                      <input
                        type="number"
                        class="form-control"
                        min="0"
                        placeholder="อายุของทรัพย์สิน(วัน)"
                        v-model="ebExprie"
                        name="ebExprie"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <label class="label-required">สถานะทรัพย์สินเช่า:</label>
                      <treeselect 
                        v-model="ebIsLeasedAssets"
                        name="ebIsLeasedAssets"
                        :options="ebIsLeasedAssetsOptions"
                        :class="{ 'invalid-treeselect': ebIsLeasedAssets === null || ebIsLeasedAssets === undefined }"
                        placeholder="กรุณาเลือก"
                        ref="ebIsLeasedAssets"
                      />
                      <span class="form-text text-danger" 
                        style="font-size: 80%;" 
                        v-if="ebIsLeasedAssets === null || ebIsLeasedAssets === undefined"
                      >กรุณาเลือก สถานะทรัพย์สินเช่า</span>
                    </div>
                  </div>

                  <div class="col-xl-12" style="display: none;">
                    <!--begin: Datatable -->
                    <table
                      class="table-sm table-striped- table-bordered table-hover table-checkable"
                      id="auditLogTable"
                    >
                      <thead>
                        <tr>
                          <th class="all" style="width:25%">วันที่แก้ไข</th>
                          <th class="all" style="width:25%">แก้ไขโดย</th>
                          <th class="all" style="width:25%">รหัสบาร์โค้ด</th>
                          <th class="all" style="width:25%">รหัสบาร์โค้ด (เก่า)</th>
                          <th class="all" style="width:25%">รหัสบาร์โค้ดเก่า</th>
                          <th class="all" style="width:25%">รหัสบาร์โค้ดเก่า (เก่า)</th>
                          <th class="all" style="width:25%">Material</th>
                          <th class="all" style="width:25%">Material (เก่า)</th>
                          <th class="all" style="width:25%">รหัสทรัย์สินเบียร์สด</th>
                          <th class="all" style="width:25%">รหัสทรัย์สินเบียร์สด (เก่า)</th>
                        </tr>
                      </thead>
                    </table>
                    <!--end: Datatable -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
            <button type="submit" class="btn btn-primary">
              <i class="la la-save"></i> บันทึกข้อมูล
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import router from "../../../router";
import select2 from "../../../Shared/Select2";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    select2,
    Treeselect,
    Datepicker
  },
  data: function() {
    let self = this;
    return {
      DatePickerFormat: "yyyy",
      isGenBarcode: false,
      ebBarcodeOld: null,
      ebDepartmentMaterialCode: null,
      ebBarcodeYear: 0,
      showDatePicker: false,
      ebAccountMaterialCode: null,
      ebBarcodeCL: null,
      ebAssetCode: null,
      ebAssetCodeOptions: [],
      ebAssetOwnerId: null,
      ebAssetOwnerOptions: [],
      ebSupplierId: null,
      ebSupplierOptions: [],
      ebWarrantyStartDate: null,
      ebWarrantyTime: null,
      ebExprie: null,
      ebIsLeasedAssets: null,
      ebIsLeasedAssetsOptions: [],
    };
  },
  methods: {
    ClearAfterselect: function() {
      $(`[class="vue-treeselect__input"]`).val("");
    },
    validateYearInput(event) {
      let value = event.target.value.replace(/\D/g, ""); // เอาเฉพาะตัวเลข
      this.ebBarcodeYear = value.slice(0, 4); // จำกัดให้พิมพ์ได้สูงสุด 4 ตัว
    },
    async LoadebMaterialCodeOptions() {
      try {
        const response = await axios.post("/Api/product/Select2ProductReport", {
          page: 1,
          all: true,
          search: "",
          ExcludeProductGroupId: 14,
        });
        if (response.status === 200) {
          this.ebAssetCodeOptions = response.data.results.map((item) => ({
            id: item.id,
            label: item.text,
          }));
        }
      } catch (error) {
        console.error("Error loading product data:", error);
      }
    },
    LoadebAssetOwnerOptions: function(e) {
      var self = this;
      axios
        .get("/Api/assetOwner/Select2SearchAssetOwner", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.ebAssetOwnerOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadebSupplierIdOptions: function(e) {
      var self = this;
      axios
        .get("/Api/Vendors/Select2Vendor", {
          params: {
            page: 1,
            all: true,
          },
        })
        .then(function(response) {
          if (response.status == 200) {
            var data = response.data.results;
            data.forEach((element) => {
              self.ebSupplierOptions.push({
                id: element.id,
                label: element.text,
              });
            });
          }
        })
        .catch(function(error) {});
    },
    LoadLeasedAssetsOptions: function (e) {
      var self = this;
      self.ebIsLeasedAssetsOptions = [];
      var data = [
        { id: 0, text: "ทรัพย์สินบริษัท" },
        { id: 1, text: "ทรัพย์สินเช่า" },
      ];
      data.forEach((element) => {
        self.ebIsLeasedAssetsOptions.push({
          id: element.id,
          label: element.text,
        });
      });
    },
    formSubmit: function(e) {
      if (!$(this.$refs.form).validate().form()) {
        return false;
      }

      let self = this;
      if (!self.ebAssetCode || !self.ebAssetOwnerId || !self.ebSupplierId || (self.ebIsLeasedAssets === null || self.ebIsLeasedAssets === undefined)) {
        return false;
      }

      self.submit();
    },
    submit() {
      let router = this.$router;
      let self = this;

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });
      axios
        .post("/Api/Barcode/EditDataBarcode", {
          BarcodeId: this.$route.params.id,
          BarcodeNoOld: this.ebBarcodeOld,
          DepartmentMaterialCode: this.ebDepartmentMaterialCode,
          BarcodeYear: this.ebBarcodeYear,
          AccountMaterialCode: this.ebAccountMaterialCode,
          BarcodeCooling: this.ebBarcodeCL,
          MaterialCode: this.ebAssetCode,
          AssetOwnerId: this.ebAssetOwnerId,
          VendorId: this.ebSupplierId,
          WarrantyStartDate: this.ebWarrantyStartDate.format("DD/MM/YYYY"), 
          WarrantyTime: this.ebWarrantyTime,
          Exprie: this.ebExprie,
          IsLeasedAssets: this.ebIsLeasedAssets
        })
        .then(function(response) {
          if (response.data.status) {
            Swal.fire("สำเร็จ", response.data.message, "success").then(
              function() {
                $(self.$el).modal("hide");
                self.$parent.reloadDataTable(false); 
              }
            );
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        })
        .finally(() => {
          KTApp.unblockPage(); // ปิด loading page ทุกกรณี
        });
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    self.isGenBarcode = false;
    self.LoadebMaterialCodeOptions();
    self.LoadebAssetOwnerOptions();
    self.LoadLeasedAssetsOptions();
    self.LoadebSupplierIdOptions();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.ebWarrantyStartDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(),
      maxDate: moment().add(30, "days"),
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    self.ebWarrantyStartDate = moment();
    $(self.$refs.ebWarrantyStartDate)
      .datepicker("update", self.ebWarrantyStartDate.format("DD/MM/YYYY"))
      .on("changeDate", function(e) {
        self.ebWarrantyStartDate = moment(e.date);
      })
      .on("blur", function () {
        let inputValue = $(this).val().trim();
        let parsedDate = moment(inputValue, "DD/MM/YYYY", true);
        if (parsedDate.isValid()) {
          self.ebWarrantyStartDate = parsedDate;
        } else {
          $(this).val(self.ebWarrantyStartDate.format("DD/MM/YYYY"));
        }
      });

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Barcode/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          self.ebBarcodeOld = response.data.barcodeIdOld;
          self.ebDepartmentMaterialCode = response.data.departmentMaterialCode;
          self.ebBarcodeYear = response.data.barcodeYear ? response.data.barcodeYear : 0;
          self.ebAccountMaterialCode = response.data.accountMaterialCode;
          self.ebBarcodeCL = response.data.barcodeCooling;
          self.ebAssetCode = response.data.materialCode;
          self.ebAssetOwnerId = response.data.assetOwner;
          self.ebSupplierId = response.data.supplierID;

          self.ebWarrantyStartDate = moment(response.data.warrantyStartDateS,"DD/MM/YYYY");
          $(self.$refs.ebWarrantyStartDate).datepicker("update", response.data.warrantyStartDateS);

          self.ebWarrantyTime = response.data.warrantyTime;
          self.ebExprie = response.data.exprie;
          self.ebIsLeasedAssets = response.data.isLeasedAssets;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    $("#EditBarcodeModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
      })
      .modal("show");

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        ebBarcodeOld: {
          required: true,
          minlength: 7,
          maxlength: 7
        },
        ebBarcodeYear: "required",
        ebWarrantyStartDate: "required",
        ebWarrantyTime: "required",
        ebExprie: "required",
      },
      messages: {
        ebBarcodeOld: {
          required: "กรุณากรอก BARCODE",
          minlength: "รหัสบาร์โค้ดต้องมี 7 ตัว",
          maxlength: "รหัสบาร์โค้ดต้องมี 7 ตัว"
        },
        ebBarcodeYear: "กรุณากรอก ปี(สินค้า)",
        ebWarrantyStartDate: "กรุณาเลือก วันที่เริ่มต้น",
        ebWarrantyTime: "กรุณากรอก ระยะเวลาประกัน(วัน)",
        ebExprie: "กรุณากรอก อายุของทรัพย์สิน(วัน)",
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>
<style>
  .invalid-treeselect .vue-treeselect__control {
    border: 1px solid #fd397a !important;
    border-radius: 4px;
  }
</style>


// WEBPACK FOOTER //
// App/Components/Master/Barcode/EditBarcode.vue